<header>
    <div class="row">
            <div class="col-sm-12">
                <div class="container header-background">
                    <a href="/"><img src="../../../assets/logo.png" alt="Comply by Edulink" title="Comply by Edulink"/></a>
                </div>
            </div>
    </div>
</header>
<main>
    <ui-view name="content"></ui-view>
</main>